/* Noren Time reviews: lightbox, read more, filters, sort, load more, carousels */
(function () {
  if (window.NTReviews) { window.NTReviews.initAll(); return; }

  var ICON = {
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  /* ---------- lightbox (single instance) ---------- */
  var lb, lbImg, lbCount, lbList = [], lbIdx = 0, lbLastFocus = null;
  function buildLightbox() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'ntr-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Review photo');
    lb.innerHTML =
      '<img class="ntr-lb__img" alt="">' +
      '<button type="button" class="ntr-lb__btn ntr-lb__close" aria-label="Close">' + ICON.close + '</button>' +
      '<button type="button" class="ntr-lb__btn ntr-lb__prev" aria-label="Previous photo">' + ICON.prev + '</button>' +
      '<button type="button" class="ntr-lb__btn ntr-lb__next" aria-label="Next photo">' + ICON.next + '</button>' +
      '<span class="ntr-lb__count"></span>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.ntr-lb__img');
    lbCount = lb.querySelector('.ntr-lb__count');
    lb.querySelector('.ntr-lb__close').addEventListener('click', closeLb);
    lb.querySelector('.ntr-lb__prev').addEventListener('click', function () { showLb(lbIdx - 1); });
    lb.querySelector('.ntr-lb__next').addEventListener('click', function () { showLb(lbIdx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') showLb(lbIdx - 1);
      if (e.key === 'ArrowRight') showLb(lbIdx + 1);
    });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) showLb(lbIdx + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }
  function showLb(i) {
    if (!lbList.length) return;
    lbIdx = (i + lbList.length) % lbList.length;
    lbImg.src = lbList[lbIdx] + (lbList[lbIdx].indexOf('?') > -1 ? '&' : '?') + 'width=1600';
    lbCount.textContent = lbList.length > 1 ? (lbIdx + 1) + ' / ' + lbList.length : '';
    var multi = lbList.length > 1;
    lb.querySelector('.ntr-lb__prev').hidden = !multi;
    lb.querySelector('.ntr-lb__next').hidden = !multi;
  }
  function openLb(list, i) {
    buildLightbox();
    lbList = list.filter(Boolean);
    lbLastFocus = document.activeElement;
    showLb(i || 0);
    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    lb.querySelector('.ntr-lb__close').focus();
  }
  function closeLb() {
    lb.classList.remove('is-open');
    lbImg.removeAttribute('src');
    document.documentElement.style.overflow = '';
    if (lbLastFocus) lbLastFocus.focus();
  }

  /* ---------- read more ---------- */
  function initClamp(root) {
    root.querySelectorAll('[data-ntr-text]').forEach(function (t) {
      if (t.dataset.ntrClampDone || t.offsetParent === null) return;
      var lh = parseFloat(getComputedStyle(t).lineHeight) || 22;
      if (t.scrollHeight > lh * 5 + 4) {
        t.classList.add('is-clamped');
        var btn = t.parentNode.querySelector('[data-ntr-more]');
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', function () {
            var open = t.classList.toggle('is-clamped');
            btn.textContent = open ? 'Read more' : 'Show less';
          });
        }
      }
      t.dataset.ntrClampDone = '1';
    });
  }

  /* ---------- filters / sort / load more ---------- */
  function initList(root) {
    var grid = root.querySelector('[data-ntr-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ntr-card]'));
    cards.forEach(function (c, i) { c.dataset.ord = i; });
    var initial = parseInt(root.dataset.initial || '8', 10);
    var step = parseInt(root.dataset.step || '8', 10);
    var state = { stars: 'all', photo: false, product: 'all', sort: root.dataset.sort || 'recent', limit: initial };
    var moreBtn = root.querySelector('[data-ntr-loadmore]');
    var results = root.querySelector('[data-ntr-results]');
    var empty = root.querySelector('[data-ntr-empty-filter]');

    function apply() {
      var list = cards.filter(function (c) {
        if (state.stars !== 'all' && c.dataset.stars !== state.stars) return false;
        if (state.photo && c.dataset.photo !== '1') return false;
        if (state.product !== 'all' && c.dataset.product !== state.product) return false;
        return true;
      });
      list.sort(function (a, b) {
        if (state.sort === 'high') return (b.dataset.stars - a.dataset.stars) || (a.dataset.ord - b.dataset.ord);
        if (state.sort === 'low') return (a.dataset.stars - b.dataset.stars) || (a.dataset.ord - b.dataset.ord);
        if (state.sort === 'photo') return (b.dataset.photo - a.dataset.photo) || (a.dataset.ord - b.dataset.ord);
        return (b.dataset.date - a.dataset.date) || (a.dataset.ord - b.dataset.ord);
      });
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= state.limit; });
      if (moreBtn) moreBtn.hidden = list.length <= state.limit;
      if (results) results.textContent = list.length + (list.length === 1 ? ' review' : ' reviews');
      if (empty) empty.hidden = list.length > 0;
      initClamp(root);
    }

    root.querySelectorAll('[data-ntr-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.ntrFilter;
        if (v === 'photo') {
          state.photo = !state.photo;
          b.setAttribute('aria-pressed', state.photo);
        } else {
          state.stars = (state.stars === v && v !== 'all') ? 'all' : v;
          root.querySelectorAll('[data-ntr-filter]:not([data-ntr-filter="photo"])').forEach(function (x) {
            x.setAttribute('aria-pressed', x.dataset.ntrFilter === state.stars);
          });
        }
        state.limit = initial; apply();
      });
    });
    root.querySelectorAll('[data-ntr-bar]').forEach(function (b) {
      b.addEventListener('click', function () {
        var chip = root.querySelector('[data-ntr-filter="' + b.dataset.ntrBar + '"]');
        if (chip) chip.click();
        var tb = root.querySelector('.ntr-toolbar');
        if (tb) tb.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var sort = root.querySelector('[data-ntr-sort]');
    if (sort && root.dataset.sort) sort.value = root.dataset.sort;
    if (sort) sort.addEventListener('change', function () { state.sort = sort.value; state.limit = initial; apply(); });
    var prod = root.querySelector('[data-ntr-product]');
    if (prod) prod.addEventListener('change', function () { state.product = prod.value; state.limit = initial; apply(); });
    if (moreBtn) moreBtn.addEventListener('click', function () { state.limit += step; apply(); });
    apply();
  }

  /* ---------- horizontal tracks (photo strip, homepage carousel) ---------- */
  function initTrack(root) {
    root.querySelectorAll('[data-ntr-track]').forEach(function (track) {
      var box = track.closest('[data-ntr-trackbox]') || root;
      var prev = box.querySelector('[data-ntr-prev]');
      var next = box.querySelector('[data-ntr-next]');
      var dots = box.querySelector('[data-ntr-dots]');
      function pageW() { return track.clientWidth; }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dots) {
          var pages = Math.max(1, Math.ceil(track.scrollWidth / Math.max(1, pageW()) - 0.05));
          if (dots.children.length !== pages) dots.innerHTML = new Array(pages + 1).join('<span></span>');
          var cur = Math.min(pages - 1, Math.round(track.scrollLeft / Math.max(1, pageW())));
          Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === cur); });
          dots.hidden = pages < 2;
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageW(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageW(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- photo clicks ---------- */
  function initPhotos(root) {
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-ntr-open]');
      if (open && root.contains(open)) {
        openLb((open.dataset.photos || '').split('|'), 0);
        return;
      }
      var strip = e.target.closest('[data-ntr-strip-i]');
      if (strip && root.contains(strip)) {
        var all = Array.prototype.map.call(root.querySelectorAll('[data-ntr-strip-i]'), function (x) { return x.dataset.src; });
        openLb(all, parseInt(strip.dataset.ntrStripI, 10));
      }
    });
  }

  /* ---------- write a review dialog ---------- */
  function initWrite(root) {
    root.querySelectorAll('[data-ntr-write]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.dataset.ntrWrite);
        if (d && d.showModal) d.showModal();
      });
    });
    root.querySelectorAll('.ntr-dialog').forEach(function (d) {
      d.querySelectorAll('[data-ntr-dialog-close]').forEach(function (c) { c.addEventListener('click', function () { d.close(); }); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      if (d.querySelector('[data-ntr-posted]') && d.showModal) d.showModal();
    });
  }

  function init(root) {
    if (root.dataset.ntrReady) return;
    root.dataset.ntrReady = '1';
    initPhotos(root);
    initList(root);
    initTrack(root);
    initClamp(root);
    initWrite(root);
  }
  function initAll() { document.querySelectorAll('[data-ntr]').forEach(init); }

  window.NTReviews = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
